import { render, staticRenderFns } from "./IconCrownBadge.vue?vue&type=template&id=76f8b9d1&"
import script from "./IconCrownBadge.vue?vue&type=script&lang=js&"
export * from "./IconCrownBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports